import React, { useState } from 'react';
import { Col, Row, Button, Typography, Input, Form } from 'antd';
import './index.less';
import { UserOutlined, MailOutlined } from '@ant-design/icons';
import { compose, graphql, Mutation, withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import logoImg from '../../assets/img/logo-white-bg.png';
import SocialMedia from '../../components/SocialMedia';
import sendImg from '../../assets/img/send.png';
import editImg from '../../assets/img/edit.png';
import footerImg from '../../assets/img/footer.png';

const submitContactForm = gql`
  mutation($form: ContactFormInput!) {
    contactForm(form: $form) {
      id
    }
  }
`;

export default function Contact() {
  const [data, setData] = useState({ email: '', firstName: '', lastName: '', comment: '' });

  const onChange = ({ target }) => {
    const newData = { ...data, [target.name]: target.value };
    setData(newData);

  };

  const { Title } = Typography;
  const validateMessages = {
    required: 'This field is required!',
    types: {
      email: 'Not a validate email!',
    },
  };
  const [form] = Form.useForm();

  const { TextArea } = Input;
  return (
    <Row className="footer-block" align="bottom" id="goContactUs">
      <Col
        xs={24}
        xxl={{ span: 9, offset: 1 }}
        xl={{ span: 8, offset: 1 }}
        lg={{ span: 8, offset: 1 }}
        md={{ span: 8, offset: 1 }}
        sm={{ span: 21, offset: 1 }}
        className="footer-box-left"
        data-aos="fade-up"
      >
        <div className="footer-logo">
          <img src={logoImg} />
        </div>
        <div className="footer-content"></div>
        <div className="footer-reachUs">
          <Typography>
            <Title level={4}>Call Us</Title>
            <p>+1(213) 282-8273</p>
          </Typography>
        </div>
        <div className="social-media">
          <Typography>
            <Title level={4}>Social Network</Title>
          </Typography>
          <div className="social-media-icon">
            <span className="social-icon">
              <SocialMedia />
            </span>
          </div>
        </div>
        <div className="copyrights">
          <p> © 2020 TransforMAX. A product of Hybrid Data LLC, Los Angeles, CA</p>
        </div>
      </Col>
      <Col
        id="goContactUs"
        xs={24}
        xxl={14}
        xl={15}
        lg={15}
        md={15}
        sm={24}
        className="footer-box-right"
        data-aos="fade-up"
      >
        <div className="footer-img img-right">
          <img src={footerImg} />
        </div>
        <div className="contact-form">
          <div className="title">
            <h1>Contact us</h1>
          </div>
          <Form name="nest-messages" form={form} validateMessages={validateMessages}>
            <Form.Item name={['user', 'firstName']}>
              <Input
                size="large"
                name="firstName"
                placeholder="First Name"
                onChange={onChange}
                suffix={<UserOutlined />}
              />
            </Form.Item>
            <Form.Item name={['user', 'lastName']}>
              <Input
                size="large"
                name="lastName"
                placeholder="Last Name"
                onChange={onChange}
                suffix={<UserOutlined />}
              />
            </Form.Item>
            <Form.Item name={['user', 'email']} rules={[{ type: 'email' }]}>
              <Input
                size="large"
                name="email"
                placeholder="Email Address"
                onChange={onChange}
                suffix={<MailOutlined />}
              />
            </Form.Item>
            <Form.Item name={['user', 'comment']}>
              <TextArea
                rows={2}
                placeholder="Message"
                name="comment"
                onChange={onChange}
                suffix={<img src={editImg} />}
              />
            </Form.Item>
            <Form.Item name={['user', 'button']}>
              <Mutation mutation={submitContactForm}>
                {submitForm => (
                  <Button
                    type="primary"
                    class="footer-sent-btn"
                    shape="round"
                    size="large"
                    onClick={() => {
                      submitForm({ variables: { form: { ...data } } });
                      form.resetFields();
                    }}
                  >
                    <span>Send</span> <img src={sendImg} />
                  </Button>
                )}
              </Mutation>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  );
}
